import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class RTWRadiographySummary extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		welderID: Joi.string().min(3).required().label('Welder ID'),
		weldNumber: Joi.string().min(3).required().label('Weld Number'),
		schedule: Joi.string().required().label('Schedule'),
		diameter: Joi.number().min(0).required().label('Diameter'),
		numberOfExposure: Joi.number()
			.integer()
			.positive()
			.min(0)
			.required()
			.label('Number Of Exposure'),
		partNumber: Joi.string().required().label('Location / Part Number'),
		density: Joi.string().required().label('Density'),
		defectType: Joi.string().required().label('Defect / Discontinuity Type'),
		defectLength: Joi.number()
			.required()
			.label('Defect / Discontinuity Length'),
		result: Joi.string().required().label('Result'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'welderID',
							label: 'Welder ID',
							placeholder: 'Enter Welder ID',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'weldNumber',
							label: 'Weld Number',
							placeholder: 'Enter Weld Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'diameter',
							label: 'Diameter',
							placeholder: 'Enter Diameter',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'schedule',
							label: 'Schedule',
							placeholder: 'Enter Schedule',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'numberOfExposure',
							label: 'Number Of Exposure',
							placeholder: 'Enter Number Of Exposure',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'partNumber',
							label: 'Location / Part Number',
							placeholder: 'Enter Location / Part Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'density',
							label: 'Density',
							placeholder: 'Enter Density',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'defectType',
							label: 'Defect / Discontinuity Type',
							placeholder: 'Enter Defect / Discontinuity Type',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'defectLength',
							label: 'Defect / Discontinuity Length',
							placeholder: 'Enter Defect / Discontinuity Length',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result',
							placeholder: 'Select Result',
							options: data.getResultOptions(),
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default RTWRadiographySummary;

const initialData: models.RTWRadiographySummaryData = {
	welderID: '',
	weldNumber: '',
	schedule: '',
	diameter: 0,
	numberOfExposure: 0,
	partNumber: '',
	density: '',
	defectType: '',
	defectLength: 0,
	result: '',
};
